<h1 class="mb-4"><mdb-icon fas icon="cog"></mdb-icon> Consulta recorridos</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Liquidación Recorridos</span>
      <span> /</span>
      <span>Consulta recorridos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row mb-2 filtros-body">
        <div class="col" style="max-width: 240px;">
          <!-- Material checked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_RESUMEN" />
            <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
          </div>
          <!-- Material unchecked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_DETALLE" />
            <label class="form-check-label" for="rbVistaDetalle">Vista Detallada</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" formControlName="fechaDesde"
              [placeholder]="'Fecha desde'" required></mdb-date-picker>
            <div
              *ngIf="formHeader.get('fechaDesde').invalid && (formHeader.get('fechaDesde').dirty || formHeader.get('fechaDesde').touched)">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechahasta" formControlName="fechaHasta"
              [placeholder]="'Fecha hasta'" required></mdb-date-picker>
            <div
              *ngIf="formHeader.get('fechaHasta').invalid && (formHeader.get('fechaHasta').dirty || formHeader.get('fechaHasta').touched)">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form">
            <mdb-select [options]="optionsEstado" formControlName="listaEstado" [multiple]="true" [filterEnabled]="true"
              [highlightFirst]="false" placeholder="Seleccionar estado" selectAllLabel="Todos"></mdb-select>
            <label>Estado</label>
          </div>
        </div>
        <div class="col dato" style="max-width: 300px">
          <div class="md-form">
            <input value="" type="text" id="descRecorrido" class="form-control" placeholder="Código" onlyNumbers
              formControlName="codigoRecorrido" />
            <label for="descRecorrido">Código de recorrido</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="9.999.999-9" #rutcliente
              formControlName="rutCliente" formatRut />
            <label>Rut Cliente</label>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 37%;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarcliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents" *ngIf="cliente">
            {{ cliente.razon_social }}
          </h6>
        </div>

        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="number" id="nroDoc" class="form-control" formControlName="nroDoc"
              placeholder="Nro. de Doc" #nroDoc />
            <label for="nroDoc">Nro. de Documento</label>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div class="resultados pl-2"></div>
      <div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="LimpiarData()">Limpiar</button>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
          <mdb-icon fas icon="search"></mdb-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body p-1 justify-content-between">
    <div *ngIf="resumen_loading || detalle_loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="resumen_loading || detalle_loading" spinnerColor="blue"></mdb-spinner>
    </div>
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="resumen_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Rec.</th>
            <th scope="col">Fecha Rec.</th>
            <th scope="col">Patente</th>
            <th scope="col">Rut Chofer</th>
            <th scope="col">Chofer</th>
            <th scope="col" class="text-right">Total</th>
            <th scope="col" class="text-center">Estado</th>
            <th scope="col" class="text-right">Total Liq.</th>
            <th scope="col">Fec. Liq.</th>
            <th scope="col" class="text-right">Efectivo</th>
            <th scope="col" class="text-right">Transferencia</th>
            <!-- <th scope="col" class="text-right">Depositos</th> -->
            <th scope="col" class="text-right">Cheque</th>
            <th scope="col" class="text-right">Nota Cred.</th>
            <th scope="col" class="text-right">Nota Deb.</th>
            <th scope="col" class="text-right">Cobro Vend.</th>
            <th scope="col" class="text-right">Anticipo</th>
            <th scope="col" class="text-right">Reverso</th>
            <th scope="col" class="text-right">Cargo Tran.</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let mov of resumen_listaMovimientos">
            <td>
              <!-- <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" mdbTooltip="Ver"
                placement="right" (click)="showConsultaRecorridoDetalle(mov)">
                <mdb-icon fas icon="eye"></mdb-icon>
              </button> -->
              {{ mov.codigo }}
            </td>
            <td>{{ mov.fecha | fecha }}</td>
            <td>{{ mov.camion_patente }}</td>
            <td>{{ mov.rutChoferFormato | rut }}</td>
            <td>{{ mov.nombreChofer }}</td>
            <td class="text-right">{{ mov.total_documentos | numerico }}</td>
            <td class="text-center">
              <mdb-badge *ngIf="mov.codigo_estado === 1" pill="true" info="true">{{ mov.nombre_estado }}</mdb-badge>
              <mdb-badge *ngIf="mov.codigo_estado === 2" pill="true" warning="true">{{ mov.nombre_estado }}</mdb-badge>
              <mdb-badge *ngIf="mov.codigo_estado === 3" pill="true" success="true">{{ mov.nombre_estado }}</mdb-badge>
            </td>
            <td class="text-right">{{ mov.total_liq | numerico }}</td>
            <td>{{ mov.fecha_liq | fecha }}</td>
            <td class="text-right">{{ mov.efectivo | numerico }}</td>
            <td class="text-right">{{ mov.transferencia | numerico }}</td>
            <!-- <td class="text-right">{{ mov.deposito | numerico }}</td> -->
            <td class="text-right">{{ mov.cheque | numerico }}</td>
            <td class="text-right">{{ mov.nota_credito | numerico }}</td>
            <td class="text-right">{{ mov.nota_debito | numerico }}</td>
            <td class="text-right">{{ mov.cobro_vendedor | numerico }}</td>
            <td class="text-right">{{ mov.anticipo | numerico }}</td>
            <td class="text-right">{{ mov.reverso | numerico }}</td>
            <td class="text-right">{{ mov.cargo_transp | numerico }}</td>
          </tr>
        </tbody>
        <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)"
          *ngIf="resumen_listaMovimientos?.length > 0"></app-pagination>
        <!-- TOTALES -->
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="5"><strong>Totales</strong></td>
            <td class="text-right"><strong>{{ resumen_totales.total_documentos | numerico }}</strong></td>
            <td></td>
            <td class="text-right"><strong>{{ resumen_totales.total_liq | numerico }}</strong></td>
            <td></td>
            <td class="text-right"><strong>{{ resumen_totales.efectivo | numerico }}</strong></td>
            <td class="text-right"><strong>{{ resumen_totales.transferencia | numerico }}</strong></td>
            <td class="text-right"><strong>{{ resumen_totales.cheque | numerico }}</strong></td>
            <td class="text-right"><strong>{{ resumen_totales.nota_credito | numerico }}</strong></td>
            <td class="text-right"><strong>{{ resumen_totales.nota_debito | numerico }}</strong></td>
            <td class="text-right"><strong>{{ resumen_totales.cobro_vendedor | numerico }}</strong></td>
            <td class="text-right"><strong>{{ resumen_totales.anticipo | numerico }}</strong></td>
            <td class="text-right"><strong>{{ resumen_totales.reverso | numerico }}</strong></td>
            <td class="text-right"><strong>{{ resumen_totales.cargo_transp | numerico }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Rec.</th>
            <th scope="col">Fecha Rec.</th>
            <th scope="col">Patente</th>
            <th scope="col">Rut Chofer</th>
            <th scope="col">Chofer</th>
            <th scope="col">Documento</th>
            <th scope="col">Cliente</th>
            <th scope="col" class="text-right">Total</th>
            <th scope="col" class="text-center">Estado</th>
            <th scope="col" class="text-right">Total Liq.</th>
            <th scope="col">Fec. Liq.</th>
            <th scope="col" class="text-right">Efectivo</th>
            <th scope="col" class="text-right">Transferencia</th>
            <!-- <th scope="col" class="text-right">Depositos</th> -->
            <th scope="col" class="text-right">Cheque</th>
            <th scope="col" class="text-right">Nota Cred.</th>
            <th scope="col" class="text-right">Nota Deb.</th>
            <th scope="col" class="text-right">Cobro Vend.</th>
            <th scope="col" class="text-right">Anticipo</th>
            <th scope="col" class="text-right">Reverso</th>
            <th scope="col" class="text-right">Cargo Tran.</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of detalle_listaMovimientos">
            <td *ngIf="mov.codigo  === 0">{{ mov.recorrido_codigo_repetido | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.codigo | numerico }}</td>

            <td *ngIf="mov.codigo === 0">{{ mov.fecha | fecha }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.fecha | fecha }}</td>

            <td *ngIf="mov.codigo === 0">{{ mov.camion_patente }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.camion_patente }}</td>

            <td *ngIf="mov.codigo === 0">{{ mov.chofer_rut }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.chofer_rut }}</td>

            <td *ngIf="mov.codigo === 0">{{ mov.nombreChofer }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.nombreChofer }}</td>

            <td *ngIf="mov.codigo === 0">FE-{{ mov.folio | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold"></td>

            <td *ngIf="mov.codigo === 0">[{{ mov.rutFormato | rut }}] {{ mov.razon_social }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right"></td>

            <td *ngIf="mov.codigo === 0">{{ mov.total_documentos | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.total_documentos | numerico }}</td>

            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.nombre_estado }}</td>
            <td *ngIf="mov.codigo > 0" class="text-center">
              <mdb-badge *ngIf="mov.codigo_estado === 1" pill="true" info="true">{{ mov.nombre_estado }}</mdb-badge>
              <mdb-badge *ngIf="mov.codigo_estado === 2" pill="true" warning="true">{{ mov.nombre_estado }}</mdb-badge>
              <mdb-badge *ngIf="mov.codigo_estado === 3" pill="true" success="true">{{ mov.nombre_estado }}</mdb-badge>
            </td>

            <td *ngIf="mov.codigo === 0"></td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.total_liq | numerico }}</td>

            <td *ngIf="mov.codigo === 0" class="text-right"></td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold">{{ mov.fecha_liq | fecha }}</td>

            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.efectivo | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.efectivo | numerico }}</td>

            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.transferencia | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.transferencia | numerico }}</td>

            <!-- <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.deposito | numerico }}</td>
                <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.deposito | numerico }}</td> -->
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.cheque | numerico }}</td>
            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.cheque | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.nota_credito | numerico }}</td>
            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.nota_credito | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.nota_debito | numerico }}</td>
            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.nota_debito | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.cobro_vendedor | numerico }}</td>
            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.cobro_vendedor | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.anticipo | numerico }}</td>
            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.anticipo | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.reverso | numerico }}</td>
            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.reverso | numerico }}</td>
            <td *ngIf="mov.codigo > 0" class="font-weight-bold text-right">{{ mov.cargo_transp | numerico }}</td>
            <td *ngIf="mov.codigo === 0" class="text-right">{{ mov.cargo_transp | numerico }}</td>
          </tr>
        </tbody>
        <!-- <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="7"><strong>Totales</strong></td>
            <td class="text-right">{{detalle_totales.monto_neto | numerico}}</td>
            <td class="text-right">{{detalle_totales.descuento | numerico}}</td>
            <td class="text-right">{{detalle_totales.neto_total | numerico}}</td>
          </tr>
        </tbody> -->
        <app-pagination [context]="detalle_paginationContext" (onPageChange)="detalleOnPageChange($event)"
          *ngIf="detalle_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>

  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="resumenDownloadExcelPdf('XLS')">Excel</button>
    <!-- <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm">Imprimir</button> -->
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="detalleDownloadExcelPdf('XLS')">Excel</button>
    <!-- <button mdbBtn type="button" size="sm" color="success" mdbWavesEffect class="btn btn-sm">Imprimir</button> -->
  </div>
</div>

<!-- MODAL Detalle Documento-->
<app-modal-consulta-recorrido-detalle></app-modal-consulta-recorrido-detalle>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT_BLO_DESB" (onSelectSingle)="onClienteSeleccionado($event)"
  (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>